import { useEffect, useRef, useState } from "react";
import { api } from "./api";

// Cart lives on the server, tied to this browser by an httpOnly cookie.
export function useServerCart(enabled) {
  const [items, setItems] = useState([]);
  const synced = useRef(null);

  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    api
      .get("/cart")
      .then((r) => {
        if (!alive) return;
        const saved = r.data.items || [];
        synced.current = JSON.stringify(saved);
        setItems((prev) => (prev.length ? prev : saved));
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [enabled, setItems]);

  useEffect(() => {
    const json = JSON.stringify(items);
    if (synced.current === null || json === synced.current) return undefined;
    const timer = setTimeout(() => {
      synced.current = json;
      api.put("/cart", { items }).catch(() => {});
    }, 250);
    return () => clearTimeout(timer);
  }, [items]);

  return [items, setItems];
}
